import css from "styled-jsx/css";
import { HEADER_DESKTOP_MENU_NARROW_SCREEN_MAX_WIDTH, MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH } from "constants/vp-sizes";
import Colors from "styles/colors";
import { BACKGROUND_GRAY_COLOR_NAME } from "styles/color-consts";
import { SEPERATOR_LEFT_MARGIN, SEPERATOR_RIGHT_MARGIN } from "../sections-header-menu/constants";

const SEPERATOR_RIGHT_MARGIN_PX = `${SEPERATOR_RIGHT_MARGIN}px`;
const SEPERATOR_LEFT_MARGIN_PX = `${SEPERATOR_LEFT_MARGIN}px`;

export const componentStyles = css.global`
  .structured-header-menu-component {
    width: 100%;
    background-color: ${Colors.white};
    display: flex;
    justify-content: center;
    .structured-header-menu {
      max-width: ${`${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px`};
      width: 100%;
      height: 100%;
      display: flex;
      padding: 0px 32px;
      .structured-header-menu-top-part {
        display: flex;
        .structured-header-menu-content {
          width: 100%;
          .header-menu-sections-wrapper {
            max-width: ${`${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px`};
            width: 100%;
            height: 100%;
            display: flex;
            margin: auto;
            .sections-separator {
              border-right: 1px solid;
              border-color: ${Colors[BACKGROUND_GRAY_COLOR_NAME]};
              margin: 0 ${SEPERATOR_RIGHT_MARGIN_PX} 0 ${SEPERATOR_LEFT_MARGIN_PX};
              &.products {
                margin-right: 80px;
              }
              &.mondayProducts {
                margin-right: 64px;
              }
            }
            .header-menu-section-component-wrapper {
              padding: 48px 0 0px;
              background-color: var(--section-background-color);
              min-height: 400px;
              &.has-background-color {
                flex: 1;
                padding-left: 54px;
                padding-top: 48px;
                padding-bottom: 32px;
              }
            }
          }
        }
      }
      .structured-header-menu-bottom-part {
      }
    }
  }

  @media (max-width: ${HEADER_DESKTOP_MENU_NARROW_SCREEN_MAX_WIDTH}) {
    .structured-header-menu-component {
    }
  }
`;
